<template>
	<div class="comLanguagePopup_container" v-if="show">
		<van-popup v-model="bottomPopShow" position="bottom" :close-on-click-overlay="false">
			<van-picker :title="$t(title)" show-toolbar :columns="optionList" :default-index="defaultValue"
				:confirm-button-text="$t('确认')" :cancel-button-text="$t('取消')" @confirm="onConfirm"
				@cancel="onCancel" />
		</van-popup>
	</div>
</template>

<script>
import { langList } from "@/utils/IndexComponents"
import i18n from "@/lang";
export default {
	name: 'ComLanguagePopup',
	props: {
		options: {
			type: Array,
			default: () => []
		},
		title: {
			type: String,
			default: '选择语言'
		},
		show: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		optionList() {

			return this.options.map(item => {
				if (item.text) {


					return {
						text: item.text,
						...item
					}
				} else {
					return item
				}
			})
		}
	},

	data() {
		return {
			bottomPopShow: true,
			defaultValue: 0,
		}
	},
	mounted() {

		const name = process.env.VUE_APP_PROJECT_NAME
		let index = langList[name].findIndex(item => item.value === this.$i18n.locale)
		this.defaultValue = index;
	},
	methods: {
		onConfirm(e) {
			const name = process.env.VUE_APP_PROJECT_NAME
			let index = langList[name].findIndex(item => item.title === e)
			this.defaultValue = index;
			this.$emit('confirm', e);
		},
		onCancel() {
			this.$emit('cancel');
		}
	}
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>